import { EnquiryRequestService } from 'client/services';

const action = async ({ request }) => {
    if (request.method === 'DELETE') {
        const { enquiryIds } = Object.fromEntries(await request.formData());
        if (enquiryIds) {
            await EnquiryRequestService.deleteEnquiries(enquiryIds);
            return { deleted: true };
        }
    }
    return {};
};

export default action;
